module.exports = __webpack_public_path__ + "313a27250b91a4d97ef9ebeb70b08ee7.jpg";